module.exports = __webpack_public_path__ + "static/media/thumb-1920-982990.878bec79.jpg";